import { createAction } from 'redux-actions'

exports.toggleLoading = createAction('TOGGLE_LOADING')
exports.toggleCreateDetection = createAction('TOGGLE_CREATE_DETECTION')



// WEBPACK FOOTER //
// ./src/actions/app.js